import axios from 'axios';
import { logger } from '@/infrastructure/services/LoggerService';
/**
 * Tries the portal search endpoint and falls back to the legacy list endpoint
 * when the search throws (e.g. 405 while the POST is still being built out).
 * TODO: remove fallback once all portal search endpoints are complete.
 *
 * The fallback returns the *unfiltered* legacy list, so it is only safe when no
 * filter is applied (an empty saved-filter search and the plain list are
 * equivalent). When a filter is active — a saved view (`filterId`) or an inline
 * advanced-filter AST (`ast`) — set `allowFallback: false`: a failure then
 * re-throws so the caller surfaces an error state instead of silently degrading
 * to the full list, which would read as "the filter matched everything".
 */
export async function searchWithFallback(search, fallback, options = {}) {
    const { allowFallback = true } = options;
    try {
        return await search();
    }
    catch (err) {
        if (axios.isCancel(err))
            throw err;
        if (!allowFallback) {
            logger.error('Portal filtered search failed — surfacing error (no unfiltered fallback)', err);
            throw err;
        }
        logger.error('Portal search endpoint failed — falling back to legacy list endpoint', err);
        return fallback();
    }
}
